import {
  CaretRightOutlined,
  RightOutlined,
  MinusCircleOutlined,
  PlusOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import { Row, Col, Form, Input, Divider, Select, Button, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import accountService from "../../../api/account.service";
import ProgrammeCommercialService from "../../../api/programme.commercial.service";
import { addOtherItemsStore } from "../../../store/otherItemSlice";
import { FORM_NAME_COMPONENT_DETAILS_ADMISSION, SUCCESS_STATUS } from "../../../utility/Constants";
import commonUtility from "../../../utility/Utils";
import { useNavigate, useParams } from "react-router-dom";
const { Option } = Select;



function OtherItems(props) {
  const dispatch = useDispatch();
  const params = useParams();
  let navigate = useNavigate();
  const x = props.initialValuesOtherItemList;
  const [cgstList, setCgstList] = useState([]);
  const [sgstList, setSgstList] = useState([]);
  const [formDetailKeyName, setFormDetailKeyName] = useState("");
  const [progCommercialCompOtherList, setProgCommercialCompOtherList] =
    useState([]);
  const [formDetailStateX, setFormDetailStateX] = useState([]);
  const [itemObject, setItemObject] = useState({});
  const [initialOtherItems, setInitialOtherItems] = useState([]);
  const [compid, setCompid] = useState(false);
 // const [initialOtherItems, setInitialOtherItems] = useState(props.enrollmentForm.getFieldValue("component_details_others"));



 const handleFormInputChange = (index) => {
  let data = [...formDetailStateX];
  //console.log("data",data)
  //alert("index"+index)
  if(index!=undefined && index!=null){
    data[index].discount = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"discount"]);
    data[index].taxable_amount = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"taxable_amount"]);
    data[index].item_qty = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"item_qty"]);
    data[index].item_amount = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"item_amount"]);
    data[index].amount = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"amount"]);
    data[index].cgst_id = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"cgst_id"]);
    data[index].cgst_rate = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"cgst_rate"]);
    data[index].cgst_amount = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"cgst_amount"]);
    data[index].sgst_id = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"sgst_id"]);
    data[index].sgst_rate = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"sgst_rate"]);
    data[index].sgst_amount = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"sgst_amount"]);
    data[index].net_amount = props.enrollmentForm.getFieldValue([formDetailKeyName,index,"net_amount"]);
  }
  setFormDetailStateX(data);
}


  useEffect(() => {
    const data = {
      formdata: { gstType: "CGST", usedfor: "I" },
    };
    accountService.gstListByInputType(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setCgstList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    const data = {
      formdata: { gstType: "SGST", usedfor: "I" },
    };
    accountService.gstListByInputType(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setSgstList(res.data.response_data);
      }
    });
  }, []);



  useEffect(() => {
    setFormDetailKeyName(props.detailInputKey)
  }, [formDetailKeyName]);

  useEffect(()=>{
    
    //default value of item
    props.enrollmentForm.setFieldsValue({
      item_qty: 1
    });
  },[params]);

  const onDiscountChange = (e, i) => {
    
    //const indexValue = e.target.attributes.index.value;
    const discount = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      i,
      "discount",
    ]);
    const admission_amount = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      i,
      "amount",
    ]);

    const item_total_amount = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      i,
      "item_total_amount",
    ]);

    //const taxable_value = parseFloat(commonUtility.sanitizeValue(admission_amount)) - parseFloat(commonUtility.sanitizeValue(discount));
    const taxable_value = parseFloat(commonUtility.sanitizeValue(item_total_amount)) - parseFloat(commonUtility.sanitizeValue(discount));

    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, i, "taxable_amount"],
        value: taxable_value > 0 ? taxable_value : 0,
      },
    ]);

    //calulatePayable(i);
    handleFormInputChange(i);
  

    const cgst_rate = props.enrollmentForm.getFieldValue([formDetailKeyName,i,"cgst_rate"])
    const sgst_rate = props.enrollmentForm.getFieldValue([formDetailKeyName,i,"sgst_rate"])
    
    
    onSelectCGST(e,"OTHER",i,cgst_rate)
    onSelectSGST(e,"OTHER",i,sgst_rate)

  };

  const onSelectCGST = (e,tag , i , rate) => {

    let indexValue = 0;
    let rateValue = 0;

    if(tag=="DROPDOWN"){
      indexValue = e.index
      rateValue = e.rate
    }
    else{
      indexValue = i
      rateValue = rate 
    }
    const taxable = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      indexValue,
      "taxable_amount",
    ]);
   
    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, indexValue, "cgst_amount"],
        value: commonUtility.round2((taxable * rateValue) / 100),
      },
      {
        name: [formDetailKeyName, indexValue, "cgst_rate"],
        value: rateValue,
      },
    ]);
    calulateTotalGST(indexValue);
    calulatePayable(indexValue);
    handleFormInputChange(indexValue);
  };

  const onSelectSGST = (e,tag , i , rate) => {
    
    let indexValue = 0;
    let rateValue = 0;

    if(tag=="DROPDOWN"){
      indexValue = e.index
      rateValue = e.rate
    }
    else{
      indexValue = i
      rateValue = rate 
    }


    const taxable = props.enrollmentForm.getFieldValue([
      formDetailKeyName,
      indexValue,
      "taxable_amount",
    ]);
    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, indexValue, "sgst_amount"],
        value: commonUtility.round2((taxable * rateValue) / 100),
      },
      {
        name: [formDetailKeyName, indexValue, "sgst_rate"],
        value: rateValue,
      },
    ]);
    calulateTotalGST(indexValue);
    calulatePayable(indexValue);
    handleFormInputChange(indexValue);
  };


  const calulateTotalGST = (i) => {

    const cgst_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "cgst_amount",
      ])
    );
    const sgst_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "sgst_amount",
      ])
    );



    const total_gst = commonUtility.round2(parseFloat(cgst_amount) + parseFloat(sgst_amount));

    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, i, "total_gst_amount"],
        value: total_gst.toFixed(2),
      },
    ]);

  };


  const calulatePayable = (i) => {
    const taxable_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "taxable_amount",
      ])
    );
    const cgst_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "cgst_amount",
      ])
    );
    const sgst_amount = commonUtility.sanitizeValue(
      props.enrollmentForm.getFieldValue([
        formDetailKeyName,
        i,
        "sgst_amount",
      ])
    );



    const total_payable = commonUtility.round2(parseFloat(taxable_amount) + parseFloat(cgst_amount) + parseFloat(sgst_amount));

    props.enrollmentForm.setFields([
      {
        name: [formDetailKeyName, i, "net_amount"],
        value: total_payable.toFixed(2),
      },
    ]);
  };

  const onSelectOtherItems = (x, object) => {
    
    setItemObject({
      component_id:object.component_id,
      description:object.description,
      item_amount:object.amount,
      cr_ac_id:object.account_id,
      cgst_id:object.cgst_id,
      cgst_rate:object.cgst_rate,
      cgst_rate_text:`${commonUtility.sanitizeValue(object.cgst_rate)}%`,
      sgst_id:object.sgst_id,
      sgst_rate:object.sgst_rate,
      sgst_rate_text:`${commonUtility.sanitizeValue(object.sgst_rate)}%`,
    })
  }

  const addOtherItems = () => {

    let item_qty = 0;
    item_qty = props.enrollmentForm.getFieldValue('item_qty') != undefined ? props.enrollmentForm.getFieldValue('item_qty') : 0;

    if (itemObject.component_id > 0 && item_qty>0 ) {

    let cgst_amount = 0;
    let sgst_amount = 0;
    let total_gst_amt = 0;

    
    let total_item_amount = item_qty * itemObject.item_amount;

    //console.log('total_item_amount',total_item_amount);

    //let payable_amount = itemObject.amount;
    let payable_amount = total_item_amount;

    if (commonUtility.sanitizeValue(itemObject.cgst_rate) > 0 && commonUtility.sanitizeValue(itemObject.sgst_rate) > 0 && itemObject.item_amount > 0) {

      // cgst_amount = (parseFloat(itemObject.amount) * parseFloat(itemObject.cgst_rate)) / 100;
      // sgst_amount = (parseFloat(itemObject.amount) * parseFloat(itemObject.sgst_rate)) / 100;
      // total_gst_amt = cgst_amount + sgst_amount;
      // payable_amount = itemObject.amount + total_gst_amt;

      cgst_amount = commonUtility.round2((parseFloat(total_item_amount) * parseFloat(itemObject.cgst_rate)) / 100);
      sgst_amount = commonUtility.round2((parseFloat(total_item_amount) * parseFloat(itemObject.sgst_rate)) / 100);
      total_gst_amt = commonUtility.round2(cgst_amount + sgst_amount);
      payable_amount = commonUtility.round2(parseFloat(total_item_amount) + total_gst_amt);

    }

      setFormDetailStateX([...formDetailStateX, {
        component_id: itemObject.component_id,
        description: itemObject.description,
        month_id: 0,
        year: 0,
        item_amount:itemObject.item_amount,
        item_qty: item_qty,
        amount: total_item_amount,
        cr_ac_id: itemObject.cr_ac_id,
        discount: 0,
        taxable_amount: total_item_amount,
        cgst_id: itemObject.cgst_id,
        cgst_rate: commonUtility.sanitizeValue(itemObject.cgst_rate),
        cgst_rate_text: itemObject.cgst_rate_text,
        cgst_amount: cgst_amount,
        sgst_id: itemObject.sgst_id,
        sgst_rate:  commonUtility.sanitizeValue(itemObject.sgst_rate),
        sgst_rate_text: itemObject.sgst_rate_text,
        sgst_amount: sgst_amount,
        total_gst_amount: total_gst_amt,
        net_amount: payable_amount,
      }]);

      props.enrollmentForm.setFieldsValue({
        select_other_items: "",
        item_qty: 1,
      });

      setItemObject({
        component_id: 0,
        description: "",
        item_amount: 0,
        item_qty: 1,
        amount: 0,
        cr_ac_id: 0,
        discount: 0,
        taxable_amount: 0,
        cgst_id: 0,
        cgst_rate: 0,
        cgst_amount: 0,
        sgst_id: 0,
        sgst_rate: 0,
        sgst_amount: 0,
        total_gst_amount: 0,
        net_amount: 0,
      })
    }
    else{
      commonUtility.openNotificationWithType("error","rightBottom","Error","Item and item quantity is required");
    }

    props.onFormCalculation()
  }

  const handleRemove = (index) => {
    
    const list = [...formDetailStateX];
    list.splice(index, 1);
   
    setFormDetailStateX(list);
    //props.onFormCalculation();


      /**
     * This value can be any thing it is just using for refresh react layout
     */
       const x = {
        remove_id:1,
        other_items:'for refresh'
    }
    dispatch(addOtherItemsStore(x))
      
    
    
  };

  useEffect(() => {
    const data = {
      formdata: { programme_id: 0, component_type: "OTHERS", group_id: 0 , is_gst_applicable : props.isGST },
    };
    ProgrammeCommercialService.programmeCommercialByOptions(data).then(
      (res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setProgCommercialCompOtherList(res.data.response_data);
        }
      }
    );
  }, [props.isGST]);


 





  useEffect(() => {
     props.enrollmentForm.setFieldsValue({ component_details_others: formDetailStateX });
  }, [formDetailStateX]);


  // useEffect(()=>{

  //   setInitialOtherItems(props.initialValuesOtherItemList);
  //   console.log("sdgdfh",initialOtherItems)

  // },[props.enrollmentForm.getFieldValue("component_details_others")])


  useEffect(()=>{
    let paymentdtls = props.initialValuesOtherItemList;
    


    const newData = paymentdtls.map(details => { 
        return {...details}
  });


  
  setFormDetailStateX(newData)
  props.enrollmentForm.setFieldsValue({ "component_details_others": formDetailStateX });
  
    
  //setFormDetailStateX([...formDetailStateX,newData ]);


   


  
},[props.initialValuesOtherItemList]);

useEffect(() => {
  props.onFormCalculation()
}, [formDetailStateX])

  return (
    <div>




<Row gutter={20}>
              <Col xs={24} xl={6} >
                <Form.Item

                  name="select_other_items"         
                  label="Items"
                >
                  <Select
                    className="text-left"
                    defaultValue="Select"
                    onSelect={(value, event) => onSelectOtherItems(value, event)}
                  >
                    {progCommercialCompOtherList.length > 0
                      ? progCommercialCompOtherList.map((prog_commercial_other_list) => (
                        <Option
                          key={prog_commercial_other_list.component_id}
                          value={prog_commercial_other_list.component_id}
                          component_id={prog_commercial_other_list.component_id}
                          description={prog_commercial_other_list.description}
                          amount={prog_commercial_other_list.amount}
                          account_id={prog_commercial_other_list.account_id}
                          cgst_id={prog_commercial_other_list.cgst_id}
                          cgst_rate={prog_commercial_other_list.cgst_rate}
                          sgst_id={prog_commercial_other_list.sgst_id}
                          sgst_rate={prog_commercial_other_list.sgst_rate}
                        >
                          {prog_commercial_other_list.description}
                        </Option>
                      ))
                      : ""}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} xl={3}>
                <Form.Item name="item_qty"label="Qty" >
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col xs={24} xl={6} >
                <Form.Item
                  label=" "
                >



                  <Button
                    className="custom-button-green"
                    onClick={() => {
                      addOtherItems()
                    }}
                    icon={<PlusOutlined />}
                  >
                    Add Other Item
                  </Button>
                </Form.Item>
              </Col>
            </Row>



      <Form.List
        // name={FORM_NAME_COMPONENT_DETAILS_ADMISSION}
        name={props.detailInputKey}
      // initialValue={defaultFields}
      >

        {(fields, { add, remove })  => (
          <>
            {
            fields.map(({ key, name, ...restField }, index) => (
              <div key={key}>
                <Row
                  key={key}
                  style={{
                    display: "flex",
                    marginBottom: 2,
                    borderBottom: "0px solid red",
                    background : "#F9F9F9",
                    padding : "1%",
                    marginBottom : "1%",
                    borderRadius: "10px",
                    border:"1px solid #d9d9d9"
                  }}
                  align="baseline"
                  gutter={8}
                >
                  <Col xs={24} xl={6}>
                    <Form.Item
                      {...restField}
                      name={[name, "description"]}
                      label="Component"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>

                    <Form.Item {...restField} name={[name, "component_id"]} hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                    <Form.Item {...restField} name={[name, "month_id"]} hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                    <Form.Item {...restField} name={[name, "year"]} hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                    <Form.Item {...restField} name={[name, "cr_ac_id"]} hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                  </Col>
                  
                  <Col xs={24} xl={4}>
                    <Form.Item
                      {...restField}
                      name={[name, "item_amount"]}
                      label="Item Amount"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "item_qty"]}
                      label="Qty"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>
                  
                  <Col xs={24} xl={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "amount"]}
                      label="Amount"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "discount"]}
                      label="Discount"
                    >
                      <Input
                        placeholder=""
                        index={index}
                        onChange={(event) => onDiscountChange(event, index)}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={4}>
                    <Form.Item
                      {...restField}
                      name={[name, "taxable_amount"]}
                      label="Taxable"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "cgst_id"]}
                      label="CGST"
                      hidden={true}
                    >
                      <Select
                        className="text-left"
                        defaultValue="Select"
                        onSelect={(value, event) => onSelectCGST(event,"DROPDOWN",0,0)}
                      >
                        {cgstList.length > 0
                          ? cgstList.map((cgst_list) => (
                            <Option
                              key={cgst_list.id}
                              value={cgst_list.id}
                              index={index}
                              rate={cgst_list.rate}
                            >
                              {cgst_list.gstDescription}
                            </Option>
                          ))
                          : ""}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      {...restField}
                      name={[name, "cgst_rate_text"]}
                      label="CGST"
                    >
                      <Input placeholder="" readOnly={true}/>
                    </Form.Item>


                    <Form.Item {...restField} name={[name, "cgst_rate"]} hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "cgst_amount"]}
                      label="CGST Amt"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "sgst_id"]}
                      label="SGST"
                      hidden={true}
                    >
                      <Select
                        className="text-left"
                        defaultValue="Select"
                        onSelect={(value, event) => onSelectSGST(event,"DROPDOWN",0,0)}
                      >
                        {sgstList.length > 0
                          ? sgstList.map((sgst_list) => (
                            <Option
                              key={sgst_list.id}
                              value={sgst_list.id}
                              index={index}
                              rate={sgst_list.rate}
                            >
                              {sgst_list.gstDescription}
                            </Option>
                          ))
                          : ""}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, "sgst_rate_text"]}
                      label="SGST"
                    >
                      <Input placeholder="" readOnly={true}/>
                    </Form.Item>
                    <Form.Item {...restField} name={[name, "sgst_rate"]} hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={3}>
                    <Form.Item
                      {...restField}
                      name={[name, "sgst_amount"]}
                      label="SGST Amt"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                    <Form.Item   {...restField} name={[name, "total_gst_amount"]} hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={4}>
                    <Form.Item
                      {...restField}
                      name={[name, "net_amount"]}
                      label="Payable"
                    >
                      <Input placeholder="" readOnly={true} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} xl={2} hidden={true}>
                        <Form.Item
                          {...restField}
                          name={[name, "due_amount"]}
                          value="0"
                          label="Due"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                  <Col>
                    <Form.Item label=" ">
                    <Button type="danger" icon={<DeleteOutlined />} shape="circle" onClick={() => handleRemove(index)} /> 
                      
                 

                

                      {/* <MinusCircleOutlined  /> */}
                    </Form.Item>     
                  </Col>
                </Row>
                

                {/* <Divider style={{margin:0}} /> */}
              </div>
            ))}


            



          </>
        )}
      </Form.List>
    </div>
  );
}

export default OtherItems;
